import { render, staticRenderFns } from "./MediumItem.vue?vue&type=template&id=0bbe3042&"
import script from "./MediumItem.vue?vue&type=script&lang=js&"
export * from "./MediumItem.vue?vue&type=script&lang=js&"
import style0 from "./MediumItem.vue?vue&type=style&index=0&id=0bbe3042&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports